import { render, staticRenderFns } from "./Theme2Contact.vue?vue&type=template&id=ebf4f264&scoped=true&"
import script from "./Theme2Contact.vue?vue&type=script&lang=js&"
export * from "./Theme2Contact.vue?vue&type=script&lang=js&"
import style0 from "./Theme2Contact.vue?vue&type=style&index=0&id=ebf4f264&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf4f264",
  null
  
)

export default component.exports